export default __webpack_public_path__ + "static/media/image14.a927ae67.jpg";